import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.dustyTeal,
  tileBgColor: colors.pale,
  iconBgColor: colors.dustyTeal
};
export default imageGallery;